import angular from "angular";

import { WorkerAccount, WorkerListItem, Workers } from "@salaxy/core";

import { ApiCrudObjectController } from "../bases";
import { UiHelpers } from "../../services";

/**
 * LEGACY: This used to be the controller for viewing and editing Worker AND Employment details, but now the EmploymentCrudController is used instead.
 * @deprecated Use EmploymentCrudController instead.
 */
export class WorkerAccountCrudController extends ApiCrudObjectController<WorkerAccount, WorkerListItem> {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["Workers", "UiHelpers", "$location", "$routeParams"];

  constructor(
    fullApi: Workers,
    uiHelpers: UiHelpers,
    $location: angular.ILocationService,
    $routeParams: any,
  ) {
    super(fullApi, uiHelpers, $location, $routeParams);
  }

  /**
   * Initialization code.
   */
  public $onInit() {
    super.$onInit();
  }

  /** Implements the getDefaults of ApiCrudObjectController */
  public getDefaults() {
    return {
      listUrl: this.listUrl || "/workers",
      detailsUrl: this.detailsUrl || "/workers/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/Employments.html",
      oDataOptions: {},
    };
  }
}
